import React, { createContext } from "react";

export const NavigationContext = createContext(null);

interface INavigationProvider {
  removedLinks: any;
  setRemovedLinks: any;
  children: React.ReactNode;
}
export const NavigationProvider = (props: INavigationProvider) => {
  return (
    <NavigationContext.Provider
      value={{
        removedLinks: props?.removedLinks,
        setRemovedLinks: props?.setRemovedLinks,
      }}
    >
      {props?.children}
    </NavigationContext.Provider>
  );
};
